/**
 * <AttendanceTable
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import ReactHTMLTableToExcel from 'vendor/react-html-table-to-excel';
import { Line } from 'rc-progress';
import moment from 'moment'
import classnames from 'classnames'
import getStudentSummary from 'controllers/student/getStudentSummary'
import getStudentCustomFields from 'controllers/student/getStudentCustomFields'
import Loading from 'components/UI/Loading';
import {CSVLink} from 'react-csv';
import {Table} from 'components/UI'
import locale from '../locale.js';

class StudentTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStudentList: [],
      currentStudentListDetail: {},
      pastStudentList: [],
      pastStudentListDetail: {},
      doneFetchingCurrentStudents: false,
      doneFetchingPastStudents: false,
      customizedFields: [],
      downloaded: false,
    }
    this.csvHeader=[];
    this.csvCurrentStudentList=[];
    this.csvPastStudentList=[];
    this.currentPageForCurrentList = 1;
    this.currentPageForPastList = 1;
    this.fetchCurrentStudents = this.fetchCurrentStudents.bind(this);
  }

  componentWillMount() {
    const schoolId = localStorage.getItem('schoolId');

    getStudentCustomFields(schoolId)
      .then((result)=>{
        this.setState({customizedFields: result.student_fields_setting.fields},()=>{
          this.fetchCurrentStudents();
          this.fetchPastStudents();
        });
      })
  }

  fetchCurrentStudents() {
    this.fetchCurrentStudentList(()=>{
      this.setState({doneFetchingCurrentStudents: true})
    });
  }
  fetchPastStudents() {
    this.fetchPastStudentList(()=>{
      this.setState({doneFetchingPastStudents: true})
    });
  }
  fetchPastStudentList(done) {
    const schoolId = localStorage.getItem('schoolId');

    getStudentSummary({
      schoolId: schoolId,
      itemPerPage: 50,
      pageNumber: this.currentPageForPastList,
      studentState: 'archived',
      export: 1
    })
      .then((result)=>{
        this.setState({pastStudentList: this.state.pastStudentList.concat(result.list), pastStudentListDetail: result},()=>{
          this.csvPastStudentList = this.state.pastStudentList.map((student)=>{
            let pastStudent={};
            let separator = '';
            if(student.ssSuitNumber){
              separator = '-';
            }
            pastStudent[__('Student Status', locale)] = __('Past', locale);
            pastStudent[__('Name', locale)]= student.ssFirstName + ' ' + student.ssLastName;
            pastStudent[__('Student Number', locale)] = student.ssCode;
            pastStudent[__('Gender', locale)] = this.renderGender(student);
            pastStudent[__('DOB', locale)] = student.ssBirthday;
            pastStudent[__('Phone', locale)] = student.ssPhone;
            pastStudent[__('Email', locale)] = student.ssEmail;
            pastStudent[__('Nickname', locale)] = student.ssNickName;
            pastStudent[__('Address', locale)] = student.ssSuitNumber + separator + student.ssAddress + ' ' + student.ssCity + ' ' + student.ssProvince + ' ' + student.ssCountry+ ' ' + student.ssPostcode;
            pastStudent[__('Created On', locale)] = moment(student.ssStudentCreateTime).format('YYYY-MM-DD');
            pastStudent[__('Remark', locale)] = student.ssRemark;
            pastStudent[__('Primary Guardian Name', locale)] = student.ssParentsName;
            pastStudent[__('Primary Guardian Email', locale)] = student.ssParentsEmail;
            pastStudent[__('Primary Guardian Phone', locale)] = student.ssParentsPhone;
            pastStudent[__('Primary Guardian Relationship', locale)] = student.ssGuardianRelation;
            pastStudent[__('Secondary Guardian Name', locale)] = student.ssParents2Name;
            pastStudent[__('Secondary Guardian Email', locale)] = student.ssParents2Email;
            pastStudent[__('Secondary Guardian Phone', locale)] = student.ssParents2Phone;
            pastStudent[__('Secondary Guardian Relationship', locale)] = student.ssGuardian2Relation;
            if(this.state.customizedFields && this.state.customizedFields.length>0){
              this.state.customizedFields.forEach((item) => {
                if(student.custom_data[item.id]) {
                  if(item.type === 'checkbox'){
                    pastStudent[item.label] = student.custom_data[item.id].toString().replace(/"/g, '\'');
                  }else {
                    pastStudent[item.label] = student.custom_data[item.id];
                  }
                } else {
                  pastStudent[item.label] = '';
                }
              });
            }
            return pastStudent;
          })
        })
        if(this.currentPageForPastList>=result.pageAmount) {
          done();
          return;
        }
        this.currentPageForPastList++;
        this.fetchPastStudentList(done);
      })
  }
  fetchCurrentStudentList(done) {
    const schoolId = localStorage.getItem('schoolId');

    getStudentSummary({
      schoolId: schoolId,
      itemPerPage: 50,
      pageNumber: this.currentPageForCurrentList,
      studentState: 'all_not_archived',
      export: 1
    })
      .then((result)=>{
        this.setState({currentStudentList: this.state.currentStudentList.concat(result.list), currentStudentListDetail: result},()=>{
         this.csvCurrentStudentList = this.state.currentStudentList.map((student)=>{
            let currentStudent={};
            let separator = '';
            if(student.ssSuitNumber){
              separator = '-';
            }
            currentStudent[__('Student Status', locale)] = __('Current', locale);
            currentStudent[__('Name', locale)]= student.ssFirstName + ' ' + student.ssLastName;
            currentStudent[__('Student Number', locale)] = student.ssCode;
            currentStudent[__('Gender', locale)] = this.renderGender(student);
            currentStudent[__('DOB', locale)] = student.ssBirthday;
            currentStudent[__('Phone', locale)] = student.ssPhone;
            currentStudent[__('Email', locale)] = student.ssEmail;
            currentStudent[__('Nickname', locale)] = student.ssNickName;
            currentStudent[__('Address', locale)] = student.ssSuitNumber + separator + student.ssAddress + ' ' + student.ssCity + ' ' + student.ssProvince + ' ' + student.ssCountry+ ' ' + student.ssPostcode;
            currentStudent[__('Created On', locale)] = moment(student.ssStudentCreateTime).format('YYYY-MM-DD');
            currentStudent[__('Remark', locale)] = student.ssRemark;
            currentStudent[__('Primary Guardian Name', locale)] = student.ssParentsName;
            currentStudent[__('Primary Guardian Email', locale)] = student.ssParentsEmail;
            currentStudent[__('Primary Guardian Phone', locale)] = student.ssParentsPhone;
            currentStudent[__('Primary Guardian Relationship', locale)] = student.ssGuardianRelation;
            currentStudent[__('Secondary Guardian Name', locale)] = student.ssParents2Name;
            currentStudent[__('Secondary Guardian Email', locale)] = student.ssParents2Email;
            currentStudent[__('Secondary Guardian Phone', locale)] = student.ssParents2Phone;
            currentStudent[__('Secondary Guardian Relationship', locale)] = student.ssGuardian2Relation;
            if(this.state.customizedFields && this.state.customizedFields.length>0){
              this.state.customizedFields.forEach((item) => {
                if(student.custom_data[item.id]) {
                  if(item.type == 'checkbox'){
                    currentStudent[item.label] = student.custom_data[item.id].toString().replace(/"/g, '\'');
                  }else {
                    currentStudent[item.label] = student.custom_data[item.id];
                  }
                } else {
                  currentStudent[item.label] = '';
                }
              });
            }
            return currentStudent;
          })
        })
        if(this.currentPageForCurrentList>=result.pageAmount) {
          done();
          return;
        }
        this.currentPageForCurrentList++;
        this.fetchCurrentStudentList(done);
      })
  }
  renderDownloadBtn() {
    const {format} = this.props;

    if((!this.state.doneFetchingCurrentStudents || !this.state.doneFetchingPastStudents )&& this.state.currentStudentListDetail.pageAmount && this.state.pastStudentListDetail.pageAmount) {
      return (
        <div style={{height:40, textAlign: 'center'}}>
          <Line percent={(this.currentPageForCurrentList + this.currentPageForPastList)/(this.state.currentStudentListDetail.pageAmount+this.state.pastStudentListDetail.pageAmount)*100} strokeWidth="4" strokeColor="#346aff" />
          <p>{__('Loading...', locale) + ' ' + Math.round((this.currentPageForCurrentList + this.currentPageForPastList)/(this.state.currentStudentListDetail.pageAmount+this.state.pastStudentListDetail.pageAmount)*100) }%</p>
        </div>
      );
    }else if(this.state.doneFetchingCurrentStudents && this.state.doneFetchingPastStudents && !this.state.downloaded) {
      return(
        <span className="downloadBtnWrapper" onClick={()=>{this.setState({downloaded: true})}}>
          {
            format === 'excel' &&
            <ReactHTMLTableToExcel
              className={'btn btn-primary download-btn'}
              table='student-table'
              filename={'School Student List'}
              sheet='student_table'
              buttonText={__('Download', locale)}
            />
          }
          {
            format === 'csv' &&
            <CSVLink
              data={this.csvCurrentStudentList.concat(this.csvPastStudentList)}
              filename="School Student List.csv"
              className="btn btn-primary download-btn"
              target='_self'
            >
              {__('Download', locale)}
            </CSVLink>
          }
        </span>
      )
    } else if (this.state.doneFetchingCurrentStudents && this.state.doneFetchingPastStudents && this.state.downloaded) {
      return (
          <div>
            <h3 className='download-success-text'>{__('Download Successfully!', locale)}</h3>
            {
              format === 'excel' &&
              <ReactHTMLTableToExcel
                className={'btn-link redownload-btn'}
                table='student-table'
                filename={'School Student List'}
                sheet='student_table'
                buttonText={__('Redownload', locale)}
              />
            }
            {
              format === 'csv' &&
              <CSVLink
                data={this.csvCurrentStudentList.concat(this.csvPastStudentList)}
                filename="School Student List.csv"
                className="btn-link redownload-btn"
                target='_self'
              >
                {__('Redownload', locale)}
              </CSVLink>
            }

          </div>
      )
    }else {
      return null;
    }

  }
  renderCustomizedFieldLabel () {
    let fieldsTitle = [];
    if(this.state.customizedFields && this.state.customizedFields.length>0){
      this.state.customizedFields.forEach((item, index) => {
        fieldsTitle.push(<th key={index}>{item.label}</th>)
      });
    }
    return fieldsTitle;
  }
  renderTableFields() {
    this.csvHeader =[
      {label:'Name', key: 'ssFirstName'},
      {label:'Student Number', key: 'ssCode'},
      {label:'Gender', key: 'ssGender'},
      {label:'DOB', key: 'ssBirthday'},
      {label:'Phone', key: 'ssPhone'},
      {label:'Email', key: 'ssEmail'},
      {label:'Nickname', key: 'ssNickname'},
    ];
    return (
      <tr>
        <th>{__('Name', locale)}</th>
        <th>{__('Student Number', locale)}</th>
        <th>{__('Gender', locale)}</th>
        <th>{__('DOB', locale)}</th>
        <th>{__('Phone', locale)}</th>
        <th>{__('Email', locale)}</th>
        <th>{__('Nickname', locale)}</th>
        <th>{__('Address', locale)}</th>
        <th>{__('Created On', locale)}</th>
        <th>{__('Remark', locale)}</th>
        <th>{__('Primary Guardian Name', locale)}</th>
        <th>{__('Primary Guardian Email', locale)}</th>
        <th>{__('Primary Guardian Phone', locale)}</th>
        <th>{__('Primary Guardian Relationship', locale)}</th>
        <th>{__('Secondary Guardian Name', locale)}</th>
        <th>{__('Secondary Guardian Email', locale)}</th>
        <th>{__('Secondary Guardian Phone', locale)}</th>
        <th>{__('Secondary Guardian Relationship', locale)}</th>
        {this.renderCustomizedFieldLabel()}
      </tr>
    );
  }
  renderGender(student){
    if(student.ssGender == 0) {
      return __('Male', locale)
    }else if(student.ssGender == 1){
      return __('Female', locale)
    }else {
      return __('N/A', locale)
    }
  }
  renderCustomizedData(student) {
    let customizedDatalist = [];
    if(this.state.customizedFields && this.state.customizedFields.length> 0) {
      this.state.customizedFields.forEach((item)=>{
        if(student.custom_data[item.id]) {
          customizedDatalist.push(<td key={item.id}>{student.custom_data[item.id]}</td>)
        } else {
          customizedDatalist.push(<td key={item.id}></td>)
        }
      })
      return customizedDatalist;
    } else {
      return (
        <div style={{height:40, textAlign: 'center'}}>
          <Loading />
        </div>
      );
    }
  }
  renderStudents(list) {
    let studentList = [];
    if(list.length> 0){
      list.forEach((student)=>{
        let separator = '';
        if(student.ssSuitNumber){
          separator = '-';
        }
        studentList.push(
          <tr style={{textAlign:'center'}}>
            <td>{student.ssFirstName + ' ' + student.ssLastName}</td>
            <td>{student.ssCode}</td>
            <td>{this.renderGender(student)}</td>
            <td>{student.ssBirthday}</td>
            <td>{student.ssPhone}</td>
            <td>{student.ssEmail}</td>
            <td>{student.ssNickName}</td>
            <td>{student.ssSuitNumber + separator + student.ssAddress + ' ' + student.ssCity + ' ' + student.ssProvince + ' ' + student.ssCountry+ ' ' + student.ssPostcode}</td>
            <td>{moment(student.ssStudentCreateTime).format('YYYY-MM-DD')}</td>
            <td>{student.ssRemark}</td>
            <td>{student.ssParentsName}</td>
            <td>{student.ssParentsEmail}</td>
            <td>{student.ssParentsPhone}</td>
            <td>{student.ssGuardianRelation}</td>
            <td>{student.ssParents2Name}</td>
            <td>{student.ssParents2Email}</td>
            <td>{student.ssParents2Phone}</td>
            <td>{student.ssGuardian2Relation}</td>
            {this.renderCustomizedData(student)}
          </tr>
        )
      })
    }
    return studentList
  }

  render() {
    return (
      <div className='StudentTable'>
        {this.renderDownloadBtn()}
        <table id="student-table" style={{width:'100%', display:'none'}}>
          <tbody>
            <tr>
              <th colSpan={18+ (this.state.customizedFields? this.state.customizedFields.length : 0)} style={{textAlign: 'center', fontSize: 18, color:'#fff', backgroundColor:'#3b67bc' }}>
                {__('Current Student List', locale)}
              </th>
            </tr>
            {this.renderTableFields()}
            {this.renderStudents(this.state.currentStudentList)}
            <tr>
            </tr>
            <tr>
              <th colSpan={18+ (this.state.customizedFields? this.state.customizedFields.length : 0)} style={{textAlign: 'center', fontSize: 18, color:'#fff', backgroundColor:'#3b67bc' }}>
                {__('Past Student List', locale)}
              </th>
            </tr>
            {this.renderTableFields()}
            {this.renderStudents(this.state.pastStudentList)}
          </tbody>
        </table>
      </div>
    )
  }
}

export default StudentTable;



// WEBPACK FOOTER //
// ./src/template/Modals/Export/table/Student.js